import { createSelector } from 'reselect';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import getModuleState from './moduleStateSelector';
import DATE_FORMAT from '../constants/dateConstants';
import { getMarketConfig } from './marketConfigSelector';

dayjs.extend(utc);

export const getRequest = createSelector(
  getModuleState,
  (state) => state.get('request')
);

export const getDates = createSelector(
  getRequest,
  (request) => ({
    startDate: request.get('startDate'),
    endDate: request.get('endDate'),
  })
);

export const getStartLocation = createSelector(
  getRequest,
  (request) => request.get('startLocation').toJS()
);

export const getEndLocation = createSelector(
  getRequest,
  (request) => request.get('endLocation').toJS()
);

export const getStartTime = createSelector(
  getRequest,
  (request) => request.get('startTime')
);

export const getEndTime = createSelector(
  getRequest,
  (request) => request.get('endTime')
);

export const getRoomsTravelers = createSelector(
  getRequest,
  (request) => request.get('roomsTravelers').toJS()
);

export const getPartialRoomMaxAdvanceBooking = createSelector(
  getDates,
  getMarketConfig,
  ({ startDate, endDate }, { MAX_ADVANCE_BOOKING }) => {
    if (endDate) {
      const startDateFormat = startDate ? dayjs(startDate, DATE_FORMAT) : dayjs.utc();
      return dayjs(endDate, DATE_FORMAT).diff(startDateFormat, 'day') + 1;
    }
    return MAX_ADVANCE_BOOKING;
  }
);

export const getIsLocationsSwapDisabled = createSelector(
  getStartLocation,
  getEndLocation,
  ({
    query: startQuery, name: startName,
  }, {
    query: endQuery, name: endName,
  }) => !(startQuery || startName) && !(endQuery || endName)
);

export const getCountryOfResidence = createSelector(
  getRequest,
  (request) => request.get('countryOfResidence')
);
